import { makeStyles } from '@material-ui/core/styles';
export const useDefaultMethodStyle = makeStyles(theme => ({
    chooseDefaultMethodTitle: {
        //paddingTop: '34px',
        //paddingLeft: '168px',
        paddingBottom: '16px',
        fontFamily: theme.typography.subtitle2.fontFamily,
        fontStyle: 'normal',
        // fontWeight: '700',
        fontSize: theme.typography.body3Medium.fontSize,
        lineHeight: '24px',
        color: theme.palette.primary.heather,
        [theme.breakpoints.down('xs')]: {
            fontSize: theme.typography.body1.fontSize,
            paddingBottom: '11px',
            marginLeft: '16px !important',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            paddingBottom: '11px',
            marginLeft: '16px !important',
        },
    },

    defaultMethodOptions: {
        //paddingLeft: '170px',
        //paddingRight: '150px',
    },

    directDebitParent: {
        paddingTop: '16px',
        //paddingLeft: '27px',
        //paddingRight: '16px',
        paddingBottom: '17px',
        marginBottom: '8px !important',
        borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
        display: 'flex',
        flexDirection: 'row',
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            marginBottom: '6px !important',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            marginBottom: '6px !important',
        },
    },

    paymentMethod: {
        // background: 'white',
        width: '100%',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '34px 150px 50px 168px',
        //padding: '30px 0',
        height: '100%',
        [theme.breakpoints.down('xs')]: {
            //padding: 16,
            padding: '39px 17px 258px 15px',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            padding: '39px 17px 258px 15px',
        },
        '& *': {
            margin: 0,
        },
    },

    directDebitPlusMethod: {
        paddingLeft: '46.33px',
        paddingRight: '110px',
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '28.33px',
            paddingRight: '35px',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            paddingLeft: '28.33px',
            paddingRight: '35px',
        },
    },

    methodName: {
        //paddingTop: '16px',
        paddingBottom: '3px',
        //paddingLeft: '46.33px',
        fontFamily: theme.typography.body2.fontFamily,
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: '16px',
        color: theme.palette.primary.heather,
        [theme.breakpoints.down('xs')]: {
            fontSize: theme.typography.inputLabel.fontSize,
            //paddingLeft: '28.33px',
        },
        '@media(min-width:600px) and (max-width:1019px)': {},
    },

    setupMethodName: {
        //paddingBottom: '17px',
        //paddingLeft: '46.33px',
        fontFamily: theme.typography.body2.fontFamily,
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: '20px',
        color: theme.palette.primary.heather,
        [theme.breakpoints.down('xs')]: {
            fontSize: theme.typography.inputLabel.fontSize,
            //paddingLeft: '28.33px',
        },
    },

    debitIcon: {
        background: `url("data:image/svg+xml,%3Csvg width='23' height='23' viewBox='0 0 23 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.5897 10.007C21.8565 3.79265 16.2248 -0.654109 10.0104 0.0790898C7.37088 0.388222 5.05237 1.58512 3.31251 3.33291C3.31251 3.33291 3.18174 3.70546 3.44727 4.05026L3.44331 4.05422L5.40908 6.16663L5.42493 6.15078C5.45267 6.17852 5.4804 6.21022 5.51607 6.23797C5.78161 6.44406 6.14624 6.47972 6.44348 6.34894C6.46726 6.34101 6.48707 6.32516 6.50688 6.3093C7.60866 5.24715 8.99976 4.58926 10.5216 4.41091C10.7951 4.37921 11.0725 4.36336 11.346 4.36336C14.8733 4.36336 17.8457 7.0108 18.2579 10.5183C18.7057 14.3349 15.9671 17.8067 12.1505 18.2545C11.8771 18.2862 11.5997 18.3021 11.3262 18.3021C7.79891 18.3021 4.82648 15.6546 4.41034 12.1472C4.22803 10.6134 4.553 9.09942 5.34169 7.77174C5.34962 7.75985 5.35756 7.744 5.36152 7.73211C5.39323 7.62907 5.43285 7.14951 5.00482 6.8483C4.85026 6.73733 4.67983 6.68185 4.50545 6.68185C4.35485 6.68185 4.09724 6.7413 4.03779 6.85623C3.01924 8.5089 2.6031 10.4033 2.82901 12.3334C3.3363 16.6454 6.98644 19.8953 11.3222 19.8953C11.6591 19.8953 11.9999 19.8755 12.3328 19.8358C14.6038 19.5703 16.633 18.4329 18.0518 16.6375C19.4706 14.8422 20.1008 12.6029 19.8353 10.332C19.328 6.01999 15.6778 2.77013 11.342 2.77013C11.0052 2.77013 10.6643 2.78995 10.3314 2.82958C8.75801 3.01585 7.31539 3.61827 6.09075 4.57341L5.30207 3.72924C6.66542 2.64331 8.3379 1.90615 10.1967 1.68817C15.5233 1.06198 20.3505 4.87065 20.9767 10.1972C21.6029 15.5238 17.7942 20.3511 12.4676 20.9773C7.14102 21.6034 2.31379 17.7948 1.68759 12.4682C1.42602 10.2607 1.92936 8.14428 2.98358 6.37272C2.98358 6.37272 3.09454 5.82183 2.6031 5.47703C2.11166 5.12826 1.67173 5.40569 1.67569 5.40965C0.38764 7.50224 -0.230612 10.0268 0.0785202 12.6584C0.811719 18.8728 6.43952 23.3195 12.6578 22.5863C18.8762 21.8531 23.3189 16.2214 22.5897 10.007Z' fill='%23892BA0' fill-opacity='0.5'/%3E%3Cpath d='M7.5459 12.8856H8.38216C8.86964 14.7206 10.2647 15.6282 11.8738 15.6282C13.3996 15.6282 14.5093 14.8752 15.1276 13.4009C14.8898 13.0798 14.4142 12.842 13.9822 12.8064C13.4947 13.8804 12.9914 14.463 11.9213 14.463C10.9067 14.463 10.122 13.9161 9.72965 12.8896H12.5792V11.8631H9.50374C9.47996 11.6967 9.47996 11.5302 9.47996 11.34C9.47996 11.1616 9.47996 10.9833 9.50374 10.8168H12.5792V9.79035H9.74155C10.1458 8.77576 10.9583 8.21695 11.9332 8.21695C12.9121 8.21695 13.5423 8.77576 13.9703 9.63579C14.3746 9.57634 14.8422 9.30288 15.0444 8.92241C14.4499 7.77703 13.4591 7.05176 11.9332 7.05176C10.3241 7.05176 8.89342 7.97123 8.38216 9.79432H7.5459V10.8208H8.21174C8.19985 10.9873 8.18794 11.1656 8.18794 11.3439C8.18794 11.5223 8.19985 11.7006 8.21174 11.8671H7.5459V12.8856Z' fill='%23892BA0' fill-opacity='0.5'/%3E%3C/svg%3E")`,
        maxWidth: '22.67px',
        height: '22.67px',
        display: 'inline-block',
        position: 'relative',
        marginLeft: '27px',
        marginTop: '7px',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '19px',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            marginLeft: '19px',
        },
    },

    creditIcon: {
        background: `url("data:image/svg+xml,%3Csvg width='28' height='20' viewBox='0 0 28 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='6' width='20' height='2' rx='1' fill='%23892BA0' fill-opacity='0.5'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M21 1C21 0.447715 20.5523 0 20 0H4C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H24C26.2091 20 28 18.2091 28 16V4C28 1.79086 26.2091 0 24 0C23.4477 0 23 0.447715 23 1C23 1.55228 23.4477 2 24 2C25.1046 2 26 2.89543 26 4V16C26 17.1046 25.1046 18 24 18H4C2.89543 18 2 17.1046 2 16V4C2 2.89543 2.89543 2 4 2H20C20.5523 2 21 1.55228 21 1Z' fill='%23892BA0' fill-opacity='0.5'/%3E%3C/svg%3E")`,
        maxWidth: '28px',
        height: '20px',
        display: 'inline-block',
        position: 'relative',
        marginLeft: '25px',
        marginTop: '8px',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '16px',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            marginLeft: '16px',
        },
    },

    sepaIcon: {
        background: `url("data:image/svg+xml,%3Csvg width='24' height='33' viewBox='0 0 24 33' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.4427 0.640235C11.8734 -0.187403 9.23136 -0.187403 6.80757 0.494717L6.80301 0.490169L6.79391 0.494717V0.499264C6.78481 0.526549 6.57109 1.09498 6.79846 1.54063C7.02129 1.97719 7.58516 2.13635 7.63973 2.14999V2.15454H7.64428H7.64883C9.64062 1.66341 11.787 1.69979 13.8834 2.37737C19.8952 4.31459 23.2103 10.7856 21.2685 16.7974C19.3313 22.8091 12.8602 26.1242 6.84848 24.1824C4.75664 23.5094 2.99679 22.2862 1.66439 20.7264H1.66894L1.66439 20.7173C1.66439 20.7173 1.07774 20.4808 0.618448 20.7127C0.159155 20.9447 0.0045519 21.5586 0.0045519 21.5586V21.5631H0C1.57342 23.5367 3.71984 25.0874 6.2937 25.915C7.35781 26.2561 8.43555 26.4562 9.50421 26.5289V30.2442H5.65249V30.2488H5.64342C5.64342 30.2488 5.24324 30.6535 5.24324 31.1537C5.24324 31.6539 5.64797 32.0587 5.64797 32.0587H5.65249V32.0632H15.1749V30.2442H11.3232V26.5107C16.5573 26.1242 21.2958 22.6409 23.0011 17.3476C25.2521 10.3809 21.4095 2.88668 14.4427 0.640235Z' fill='%23892BA0' fill-opacity='0.5'/%3E%3Cpath d='M7.86292 22.9143C13.1971 24.1785 18.5631 20.8725 19.8318 15.5383C21.1006 10.2041 17.79 4.83814 12.4558 3.5694C7.87655 2.48256 3.27453 4.76538 1.26455 8.80808L2.81977 9.76759C4.42503 6.37519 8.24036 4.43797 12.0375 5.33836C16.394 6.37519 19.0997 10.7589 18.0629 15.1154C17.0261 19.4719 12.6423 22.1776 8.28583 21.1408C4.70243 20.2904 2.24225 17.1709 2.0558 13.6693H2.0467V13.6648C2.0467 13.6648 1.62833 13.2782 1.13265 13.2873C0.646075 13.301 0.26411 13.6875 0.24592 13.7102H0.236816C0.436905 18.0258 3.45643 21.8684 7.86292 22.9143Z' fill='%23892BA0' fill-opacity='0.5'/%3E%3C/svg%3E")`,
        maxWidth: '23.64px',
        height: '32.06px',
        display: 'inline-block',
        position: 'relative',
        marginLeft: '27px',
        marginTop: '2px',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '19px',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            marginLeft: '19px',
        },
    },

    arrowIcon: {
        background: `url("data:image/svg+xml,%3Csvg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 10.6L1.4 12L7.4 6L1.4 0L0 1.4L4.6 6L0 10.6Z' fill='%23D011C9'/%3E%3C/svg%3E")`,
        maxWidth: '7.4px',
        height: '12px',
        display: 'inline-block',
        position: 'relative',
        marginTop: '12px',
    },
}));
